import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';
import qs from 'qs';

export const routes = {
  gwiMoveContactsPath: (params) => `/api/GwiMoveContacts${getQueryParams(params)}`,
  gwiMoveContactsSearchProps: () => '/api/GwiMoveContacts/SearchProperties',
  gwiMoveContactPathById: (id) => `/api/GwiMoveContacts/${id}`,
  restoreGwiMoveContactPath: (id) => `/api/GwiMoveContacts/${id}/restore`,
  auditsGwiMoveContactPathById: (id, params) => `/api/GwiMoveContacts/${id}/Audits${getQueryParams(params)}`,
  gwiMoveContactsAuditPropertiesPath: (id) => `/api/GwiMoveContacts/${id}/Audits/Properties`,
  gwiMoveContactsAuditUsersPath: (id) => `/api/GwiMoveContacts/${id}/Audits/Users`,
};

export const getGwiMoveContactsSearchProps = () => makeRequest(authFetch.get(routes.gwiMoveContactsSearchProps()));

export const getGwiMoveContactsPaginated = async (params) => {
  const query = params && Object.keys(params).length > 0 ? `?${qs.stringify(params, { indices: false })}` : '';
  return makeRequest(authFetch.get(`/api/GwiMoveContacts${query}`));
};

export const getGwiMoveContacts = (params) =>
  authFetch.get(routes.gwiMoveContactsPath(params)).catch((error) => {
    console.error(error);
    throw error;
  });

export const getContactDepartments = () => makeRequest(authFetch.get('/api/GwiMoveContacts/Departments'));

export const postGwiMoveContact = (contact) =>
  makeRequest(authFetch.put(routes.gwiMoveContactsPath(), contact));

export const getGwiMoveContact = (id) => makeRequest(authFetch.get(routes.gwiMoveContactPathById(id)));

export const deleteGwiMoveContact = (id) => makeRequest(authFetch.delete(routes.gwiMoveContactPathById(id)));

export const restoreGwiMoveContact = (id) => makeRequest(authFetch.patch(routes.restoreGwiMoveContactPath(id)));

export const getGwiMoveContactAudits = (id, params) =>
  makeRequest(authFetch.get(routes.auditsGwiMoveContactPathById(id, params)));

export const getGwiMoveContactAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.gwiMoveContactsAuditPropertiesPath(id)));

export const getGwiMoveContactAuditUsers = (id) => makeRequest(authFetch.get(routes.gwiMoveContactsAuditUsersPath(id)));
